import React, {PureComponent} from "react"
import styled from "styled-components"

import ButtonBase from "@irati/ui/src/Button"
import {FormattedMessage} from "@irati/utils/lang"

const Button = styled(ButtonBase)`
  width: 100%;
  box-shadow: inset 0 0 0 1px #d8d8d7, inset 0 -2px 0 1px #d8d8d7;
`

interface Props {
  onClick(): void
}

class LoadMore extends PureComponent<Props> {
  render() {
    const {onClick} = this.props
    return (
      <Button onClick={onClick}>
        <FormattedMessage id="recognition.polls.closedPolls.load" />
      </Button>
    )
  }
}

export default LoadMore
